import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export class SearchRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  saveNavigationData() {
    throw new Error('[SearchRepository#saveNavigationData] must be implemented')
  }

  getSearchDataFromUrl() {
    throw new Error('[SearchRepository#getSearchDataFromUrl] must be implemented')
  }
}
